import gql from 'graphql-tag'

import { UserPlanFragment } from '../../../../graphql/fragments/UserPlanFragment'
import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation changeStartDateOfPlan($plan: ID!, $start_date: Date!) {
    changeStartDateOfPlan(plan: $plan, start_date: $start_date) {
      ...UserPlanFragment
    }
  }
  ${UserPlanFragment}
`

const transformer = ({ changeStartDateOfPlan }: any) => changeStartDateOfPlan

type variables = {
  plan: string
  start_date: Date
}

export default mutationServiceCreator<variables>(mutation, transformer)
